<template>
  <b-overlay id="overlay-background" class="overlay-config calendar-seasonal" :show="loading" rounded="sm" >
    <div class="container-updade-scenario">
      <div class="table-scenario">
        <b-table ref="table" :items="items" :fields="fields" striped responsive="sm">
            <template #cell(Selecione)="row" >
              <div @click="show(row)" class="form-checkbox "> 
                <b-form-checkbox  :id="'select-scenario-'+row.index" size="lg" value="true" v-model="row.item.Selecione"></b-form-checkbox>
              </div>
            </template>
            <template #cell(nome)="row" >
              <label :for="'select-scenario-'+row.index" :id="'name-scenario-'+row.index" class="select-scenario">{{row.item.nome}}</label>
            </template>
            <template #cell(Status)="row">
              <div id="Semaforo" class="col5">
                <SemaforoVerde v-if="!(waitingSimulation && currentScenarioUpdate == row.item.nome)" :class="{'hide': !row.item.Status}"/>
                <SemaforoVermelho v-if="!(waitingSimulation && currentScenarioUpdate == row.item.nome)" :class="{'hide': row.item.Status}"/>
                <b-spinner v-if="waitingSimulation && currentScenarioUpdate == row.item.nome" class="spinner" label="Loading..."></b-spinner>
              </div>
            </template>
        </b-table>
      </div>
    </div>
    <div class="container " scope="cow-sm">
      <b-row class="groupBtn">
          <img
            v-if="!waitingSimulation"
            id="updateScenario"
            class="float-right"
            src="@/assets/play.png"
            style="margin-left: 30px"
            :title= "$t('updateScenarioButtom')"
            alt="Atualizarcenário"
            @click="sentExecuteUpdateScenario"
          />

          <img
            id="closeModalExportScenario"
            class="float-right"
            src="@/assets/sair.png"
            style="margin-left: 30px"
            :title="$t('exit')"
            alt="Sair"
            @click="$bvModal.hide('modalUpdateScenario')"
          />
      </b-row>
    </div>
  </b-overlay>
</template>

<script>
import SemaforoVerde from "@/components/utils/SemaforoVerde.vue";
import SemaforoVermelho from "@/components/utils/SemaforoVermelho.vue";
import { defaultSuccess, showError, urlMainAPI } from '../../global';
import axios from 'axios';

  export default {
    
    components: {
      SemaforoVerde,
      SemaforoVermelho,
    },

    data() {
      return {
        waitingSimulation: false,
        fields: [' ','Selecione','nome', 'Status'],
        items: [],
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
        loading: false,
        currentScenarioUpdate: "",
      }
    },
    
      methods: {
        async loadScenariosList(){
          this.loading = true;
          const url = `${urlMainAPI}/getsavedsimulationscenario`;
            await axios
              .get(url)
              .then((res) => {
                // console.log('res', res)
                this.scenarioList = res.data.filter(s => s.name != "PADRAO" && !s.isFolder).sort((a, b) =>
                  a.name > b.name
                    ? 1
                    : a.name === b.name
                    ? a.id > b.id
                      ? 1
                      : -1
                    : -1
                );
                this.items = this.scenarioList.map(s => ({...s, nome: s.name}));
                console.log('object :>> ', this.scenarioList);
              })
              .catch();
              this.loading = false;
        },
       
        async sentExecuteUpdateScenario(){
          let scenarios = this.items.filter(s=>s.Selecione)
          if (scenarios.length > 0){
            
            this.waitingSimulation= true;
            defaultSuccess(this.$t('atualizacao-iniciada-este-processo-pode-demorar-um-pouco'))
            for (const scenario of this.items) {
              if (scenario.Selecione){
                this.currentScenarioUpdate = scenario.nome
                await this.executeUpdateScenario(scenario) 
              }
            }
            this.waitingSimulation= false;
            this.$ref.table.refresh();
            let aux = this.items;
            this.items = [];
            this.items = aux;
          } else {
            showError(this.$t('e-necessario-selecionar-ao-menos-um-cenario'))
          
          }
        },

        async executeUpdateScenario(scenario){
          await axios.get(`${urlMainAPI}/executescenarioupdate/${scenario.nome}`).then(res=>{
            if (res.status == 200){
              scenario.Status= true;
              defaultSuccess(`${scenario.nome}` + this.$t('atualizado'))
            }
            else{
              showError(this.$t('ops-aconteceu-algum-problema-ao-atualizar-o-cenario') +`${scenario.nome}!`)
            }
          })
          .catch(console.error);
        },

        info(item, button) {
          this.infoModal.title = `Nome do Cenário: ${item.nome}`
          this.infoModal.content = JSON.stringify(item, null, 2)
          this.$root.$emit('bv::show::modal', this.infoModal.id, button)
        },
        
        show(teste){
          console.log('teste :>> ', teste);
        },

        resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
        
      },

    mounted() {
      this.loadScenariosList();
    },
      
      },
      created() {
        this.loadScenariosList();
      },
}
  </script>

<style scoped>

  #Semaforo {
    margin-left: 10px;
  }

  .container-updade-scenario{
    height: 50vh;
  }

  .table-scenario {
    height: 48vh;
    overflow-y: auto;
    box-shadow: 0 0 2px #0008;
    border-radius: 4px;
  }

  .form-checkbox {
    padding-left: 1rem;
  }

  .hide {
    display: none;
  }

  .spinner{
    color: #FF751B;
  }

  .select-scenario{
    cursor: pointer;
  }

</style>